module.exports = __webpack_public_path__ + "static/media/vacationScheduleMenu.723a4a15.svg";